import React from 'react'
import { ProductPageComponentProps } from '../../../interfaces'
import { SwitchContentWrapper, Title } from '../styled'
import { useWindowSize } from 'hooks'
import {
  SecondInfoFragment,
  TableContent,
  TableSeparator,
  TableWrapper,
  StyledText,
} from './styled'
import { AllocationMobileComponent, BaseTable } from 'components'
import { getFormattedAssetData, headersAssets } from './services'

export const AssetAllocationContent: React.FC<ProductPageComponentProps> = ({ store }) => {
  const [tableText, setTableText] = React.useState<string>('View all assets')
  const isMobile = false

  const { assets } = store.product

  const showAssetAllocation = () => {
    const isTableSmall = assets && assets.length <= 5

    const AssetAllocationTable: React.FC<{
      assets: (string | JSX.Element)[][]
      isSmall: boolean
    }> = ({ assets, isSmall }) => {
      const { isMobile } = useWindowSize()
      const isTableHidden = tableText === 'View all assets'
      const halfOfTable = Math.round(assets.length / 2)

      const text = isTableHidden ? 'Hide all assets' : 'View all assets'

      const firstPart = assets.slice(0, !isSmall && isTableHidden ? 5 : halfOfTable)
      const mobileHidden = assets.slice(0, 10)
      const secondPart = assets.slice(
        !isSmall && isTableHidden ? 5 : halfOfTable,
        !isSmall && isTableHidden ? 10 : undefined,
      )
      return (
        <TableWrapper>
          <TableContent>
            {!isMobile ? (
              <BaseTable bodyArray={firstPart} headers={headersAssets} />
            ) : (
              <BaseTable
                bodyArray={!isSmall && isTableHidden ? mobileHidden : assets}
                headers={headersAssets}
              />
            )}
            {!isMobile ? (
              <>
                <TableSeparator />
                <BaseTable bodyArray={secondPart} headers={headersAssets} />
              </>
            ) : null}
          </TableContent>
          {!isSmall && assets.length > 10 && (
            <StyledText onClick={() => setTableText(text)}>{tableText}</StyledText>
          )}
        </TableWrapper>
      )
    }

    return (
      <SecondInfoFragment>
        {assets && isTableSmall !== undefined && (
          <>
            {isMobile ? (
              <AllocationMobileComponent
                bodyArray={getFormattedAssetData(assets)}
                headers={headersAssets}
              />
            ) : (
              <AssetAllocationTable assets={getFormattedAssetData(assets)} isSmall={isTableSmall} />
            )}
          </>
        )}
      </SecondInfoFragment>
    )
  }

  return (
    <SwitchContentWrapper>
      <Title>Asset Allocation</Title>
      {showAssetAllocation()}
    </SwitchContentWrapper>
  )
}
